<template>
  <div class="prompts-section">
    <div v-for="(category, catIndex) in prompts" :key="catIndex">
      <ion-row>
        <ion-col><h3>{{ category.category }}</h3></ion-col>
      </ion-row>
      <ion-row>
        <ion-col
            v-for="(prompt, index) in category.prompts"
            :key="index"
            size="12"
            size-sm="6"
            size-md="3"
        >
          <ion-card button @click="usePrompt(prompt)" class="equal-height-card">
            <ion-card-content class="ion-text-center">
              <ion-icon :name="prompt.icon" size="large" class="mb-2"></ion-icon>
              <p>{{ prompt.text }}</p>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </div>
  </div>
</template>

<script>
import { IonRow, IonCol, IonCard, IonCardContent, IonIcon } from '@ionic/vue';

export default {
  name: 'PromptsSection',
  components: {
    IonRow,
    IonCol,
    IonCard,
    IonCardContent,
    IonIcon,
  },
  props: {
    prompts: {
      type: Array,
      required: true,
    },
    usePrompt: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
.prompts-section {
  margin-top: 16px;
}

.mb-2 {
  margin-bottom: 8px;
}

.equal-height-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.equal-height-card ion-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

h3 {
  margin-top: 2rem;
}
</style>